module.exports = __webpack_public_path__ + "media/images/sample-sitter-1-acafd441f4235faa2e6f6455c6e034f6.jpg";